<template lang="pug">
.card.mb-3(v-if="texto.Audios")
	.card-header.bg-warning(@click="desplegado = !desplegado", style="cursor: pointer;")
		span.fa.fa-volume-up.mr-2
		| Audios
		button.close
			span.fa.fa-plus
	.card-body(v-if="desplegado && !readonly")
		.input-group
			.input-group-prepend
				.input-group-text
					span.fa.fa-search
			input-query(
				url="redaccion/php/api/buscarAudio.php"
				:realtime="false"
				@selected="addAudio($event)"
				input-class="form-control"
				placeholder="Buscar un audio en el XFrame"
				:disabled="procesando"
			)
		.text-danger.m-2.text-center(v-if="procesando", style="font-weight:bold;font-size:2em;") Procesando...
	table.table.table-striped.m-0(v-if="texto.Audios.length > 0")
		tbody
			tr(
				v-for="audio in texto.Audios"
				:key="audio.AudioID"
			)
				td.text-center(style="cursor:pointer;", @click="ReproducirID = audio.XFrameID")
					span.fa.fa-play.text-primary
				td.text-left {{audio.NombreFichero}}
				td.text-right(v-if="!readonly")
					span.fa.fa-trash.text-danger.mr-2(style="cursor:pointer", @click="delAudio(audio.AudioID)")
	Reproductor(v-if="ReproducirID", :id-objeto="ReproducirID", @cerrar="ReproducirID = null")
</template>

<script>
import Reproductor from '../../../../organizar-emisoras/vue/componentes/reproductor.vue'
import axios from 'axios'
export default {
	props: ['texto', 'readonly'],
	components: {
		Reproductor
	},
	data () {
		return {
			desplegado: false,
			ReproducirID: null,
			procesando: false
		}
	},
	methods: {
		addAudio (data) {
			if (this.readonly) {
				return
			}
			this.procesando = true
			const form = {
				NoticiaID: this.texto.NoticiaID,
				XFrameID: data.datos.ObjetoID
			}
			axios.post('redaccion/php/api/importar-audio.php', form)
				.then(res => {
					this.texto.Audios.push(res.data.audio)
					this.procesando = false
				})
				.catch(e => {
					this.$responseError(e)
					this.procesando = false
				})
		},
		delAudio (AudioID) {
			if (this.readonly) {
				return
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar audio',
				mensaje: '¿Quieres eliminar este audio?',
				callback: acepta => {
					if (acepta) {
						axios.delete('redaccion/php/api/del-audio.php?AudioID=' + AudioID)
							.then(() => {
								for (let i = 0; i < this.texto.Audios.length; i++) {
									if (this.texto.Audios[i].AudioID === AudioID) {
										this.texto.Audios.splice(i, 1)
									}
								}
								this.$store.commit('toast/success', {
									titulo: 'Eliminado',
									mensaje: 'Se ha eliminado el audio correctamente'
								})
							})
							.catch(this.$responseError)
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/audios.vue